/** @format */

import { AddToCartButtonComponent } from './add-to-cart-button.component';
import { AlertMessageModule } from '@shared/components';
import { CommonModule } from '@angular/common';
import { FavoritesIconModule } from '@shared/favorites/components';
import { FormsModule } from '@angular/forms';
import { HmfAlertBannerComponent, HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';
import { SeeAvailableStoresButtonComponent } from '../see-available-stores-button/see-available-stores-button.component';

@NgModule({
	declarations: [AddToCartButtonComponent],
	imports: [
		AlertMessageModule,
		CommonModule,
		FavoritesIconModule,
		FormsModule,
		HmfAlertBannerComponent,
		HmfButtonComponent,
		SeeAvailableStoresButtonComponent
	],
	exports: [AddToCartButtonComponent]
})
export class AddToCartButtonModule {}
